import { ENV_TYPE } from '@models/commonModel';

const LOCAL_API_URL = '';
const DEV_API_URL = '';
const STAGE_API_URL = '';
const PRODUCTION_API_URL = '';

export const getAPIByEnviorment = (): string => {
  const env: ENV_TYPE = (process.env.REACT_APP_ENV_MODE as ENV_TYPE) || 'local';

  let returnUrl: string = LOCAL_API_URL;
  switch (env) {
    case 'local':
      returnUrl = LOCAL_API_URL;
      break;
    case 'dev':
      returnUrl = DEV_API_URL;
      break;
    case 'stage':
      returnUrl = STAGE_API_URL;
      break;
    case 'production':
      returnUrl = PRODUCTION_API_URL;
      break;
    default:
      returnUrl = LOCAL_API_URL;
      break;
  }

  return returnUrl;
};

export type METHOD_TYPE = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
